import React from 'react'
import { Modal } from '@components/ui'

type MessageCenterPermanentlyDeleteEmailModalProps = {
  show: boolean
  count: number
  onCancel: () => void
  onDelete: () => void
}

const MessageCenterPermanentlyDeleteEmailModal: React.FC<
  MessageCenterPermanentlyDeleteEmailModalProps
> = ({ show, count, onCancel, onDelete }) => (
  <Modal
    open={show}
    onClose={onCancel}
    size="xs"
    title="Delete email"
    description={`Are you sure you want to delete ${count} emails permanently? This action cannot be undone.`}
    primaryLabel="Delete"
    secondaryLabel="Cancel"
    primaryDestructive
    onPrimaryClick={onDelete}
    onSecondaryClick={onCancel}
  />
)

export default MessageCenterPermanentlyDeleteEmailModal
